import type { DataTableColDef } from "../DataTable";

type ArColumn = DataTableColDef<InsuranceArEntryMessage>;

function exportCellValue(
  column: ArColumn,
  row: InsuranceArEntryMessage,
): string {
  const raw = row[column.field as keyof InsuranceArEntryMessage];
  const value = column.valueGetter ? column.valueGetter(raw, row) : raw;
  return value === null || value === undefined ? "" : String(value);
}

export function buildInsuranceArCsv(
  columns: ArColumn[],
  rows: InsuranceArEntryMessage[],
): string {
  return [
    columns.map((column) => column.headerName ?? column.field),
    ...rows.map((row) => columns.map((column) => exportCellValue(column, row))),
  ]
    .map((line) =>
      line.map((cell) => `"${cell.replace(/"/g, '""')}"`).join(","),
    )
    .join("\n");
}
